import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  companies: { count: 0, rows: [] },
  company: {},
  companiesFilter: {},
  loading: false,
  loadingInfiniteScroll: false,
  checkDelete: {}
};

const requestCompaniesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const setCompaniesFilter = (state, action) => {
  return updateObject(state, {
    companiesFilter: action.companiesFilter,
  });
};

const requestCompaniesInfiniteScrollStart = (state, action) => {
  return updateObject(state, { loadingInfiniteScroll: true });
};

const fetchCompaniesSuccess = (state, action) => {
  return updateObject(state, {
    companies: action.companies,
    loading: false
  });
};

const fetchCompaniesInfinteScrollSuccess = (state, action) => {
  const companyObj = { count: action.companies.count, rows: [...state.companies.rows, ...action.companies.rows] }
  return updateObject(state, {
    companies: companyObj,
    loadingInfiniteScroll: false
  });
};

const fetchCompanyByIdSuccess = (state, action) => {
  return updateObject(state, {
    company: action.company,
    loading: false
  });
}

const requestCompaniesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteCompaniesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteCompaniesSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updateCompaniesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postCompaniesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_COMPANIES_START: return requestCompaniesStart(state, action);
    case actionTypes.SET_COMPANIES_FILTER: return setCompaniesFilter(state, action);
    case actionTypes.REQUEST_COMPANIES_INFINITE_SCROLL_START: return requestCompaniesInfiniteScrollStart(state, action);
    case actionTypes.FETCH_COMPANIES_SUCCESS: return fetchCompaniesSuccess(state, action);
    case actionTypes.FETCH_COMPANIES_INFINITE_SCROLL_SUCCESS: return fetchCompaniesInfinteScrollSuccess(state, action);
    case actionTypes.FETCH_COMPANIES_BY_ID_SUCCESS: return fetchCompanyByIdSuccess(state, action);
    case actionTypes.REQUEST_COMPANIES_FAIL: return requestCompaniesFail(state, action);
    case actionTypes.DELETE_COMPANIES_SUCCESS: return deleteCompaniesSuccess(state, action);
    case actionTypes.CHECK_DELETE_COMPANIES_SUCCESS: return checkDeleteCompaniesSuccess(state, action);
    case actionTypes.UPDATE_COMPANIES_SUCCESS: return updateCompaniesSuccess(state, action);
    case actionTypes.POST_COMPANIES_SUCCESS: return postCompaniesSuccess(state, action);

    default: return state;
  }
};

export default reducer;